export const microLabelSx = {
	fontSize: "0.6rem",
	fontWeight: 600,
	textTransform: "uppercase",
	letterSpacing: 0.4,
	color: "#888",
} as const;
